import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import _, { update } from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import InjuredPartyForm from './InjuredPartyForm';
import PropertyDamageForm from './PropertyDamageForm';
import metadata from './Liability.metadata.json5';
import styles from './Liability.module.scss';
import { IconButton } from '@jutro/legacy/components';


function FNOLLiabilityDetails(props) {
    const {
        liabilityDetailsData: claimVM,
        updateWizardData, showErrors, onValidate, setLiabOverlayVisible
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader, authUserData } = useAuthentication();
    const { registerComponentValidation } = useValidation('FNOLLiabilityDetails');
    const [injuredPartyVM, setInjuredPartyVM] = useState({});
    const [propertyDamageVM, setPropertyDamageVM] = useState({});
    const [showInjuredPartyForm, setShowInjuredPartyForm] = useState(false);
    const [showPropDamageForm, setShowPropDamageForm] = useState(false);
    const [isEditInjuredPartyForm, setEditInjuredPartyForm] = useState(false);
    const [isEditPropDamageForm, setEditPropDamageForm] = useState(false);

    const isClaimStatus = useCallback(() => {
        return (
            _.get(claimVM.value, 'lossCause') === 'liability_TFPA'
        );
    }, [claimVM]);

    useEffect(() => {
        registerComponentValidation(isClaimStatus);
    }, [registerComponentValidation, isClaimStatus]);

    useEffect(() => {
        if (showInjuredPartyForm || showPropDamageForm) {
            setLiabOverlayVisible(true);
        } else {
            setLiabOverlayVisible(false);
        }
    }, [showInjuredPartyForm, showPropDamageForm]);

    const renderEdit = useCallback((item, index) => {
        return (
            <IconButton
                icon="mi-edit"
                id={`edit${index}`}
                size="large"
                type="tertiary"
                tooltip={{
                    placement: 'top',
                    text: 'Delete'
                }}
                onClick={() => editInjuryRecord(item)}
            />
        );
}, []);

    const renderDelete = useCallback((item, index) => {
        return (
            <IconButton
                icon="mi-delete"
                id={`delete${index}`}
                size="large"
                type="tertiary"
                tooltip={{
                    placement: 'top',
                    text: 'Delete'
                }}
                onClick={() => deleteInjuryRecord(item)}
            />
        );
    }, []);

    const renderEditPropDamage = useCallback((item, index) => {
        return (
            <IconButton
                icon="mi-edit"
                id={`editPropDamage${index}`}
                size="large"
                type="tertiary"
                tooltip={{
                    placement: 'top',
                    text: 'Delete'
                }}
                onClick={() => editPropDamageRecord(item)}
            />
        );
}, []);

    const renderDeletePropDamage = useCallback((item, index) => {
        return (
            <IconButton
                icon="mi-delete"
                id={`deletePropDamage${index}`}
                size="large"
                type="tertiary"
                tooltip={{
                    placement: 'top',
                    text: 'Delete'
                }}
                onClick={() => deletePropDamageRecord(item)}
            />
        );
    }, []);

    const onInjuredPartyClick = useCallback(async () => {
        const incidentDTO = viewModelService.create({
            incidentType: 'InjuryIncident',
            tempID: EntityUtil.nextId(),
            injuryIncidentContact: {
              subtype: 'Person',
            }
          }, 'cc', 'ext.TWIA.edge.capabilities.claim.dto.IncidentDTO', {'SubmittingClaim': true});
        setInjuredPartyVM(incidentDTO);
        setShowInjuredPartyForm(true);
    }, []);

    const onPropertyDamageClick = useCallback(async () => {
        const incidentDTO = viewModelService.create({
            incidentType: 'FixedPropertyIncident',
            tempID: EntityUtil.nextId(),
            policyLocation_TFPA: claimVM.policy?.lobs?.homeowner?.locations?.value[0],
            fixPropIncidentContact: {
              subtype: 'Person',
            }
          }, 'cc', 'ext.TWIA.edge.capabilities.claim.dto.IncidentDTO', {'SubmittingClaim': true});
          setPropertyDamageVM(incidentDTO);
          setShowPropDamageForm(true);
    }, []);

    const getFirstName = useCallback((data) => {
        return data?.injuryIncidentContact?.firstName;        
    }, []);

    const getLastName = useCallback((data) => {
        return data?.injuryIncidentContact?.lastName;
    }, []);

    const getPhoneNumber = useCallback((data) => {
        return data?.injuryIncidentContact?.homeNumber || data?.injuryIncidentContact?.cellNumber
            || data?.injuryIncidentContact?.workNumber;
    }, []);

    const editInjuryRecord = useCallback((data) => {
        const injuryIncidents = _.get(claimVM, 'incidents.value', []);
        const selectedInjuryIncidentVM = injuryIncidents.find((item) =>
            data.incidentType === item.incidentType
            && data.tempID === item.tempID
        );
        setInjuredPartyVM((prevInjuryPartyVM) => {
            let updatedPrevInjuryPartyVM = prevInjuryPartyVM;
            if (!prevInjuryPartyVM.value) {
                updatedPrevInjuryPartyVM =  viewModelService.create({
                    incidentType: 'InjuryIncident',
                    injuryIncidentContact: {
                      subtype: 'Person',
                    }
                  }, 'cc', 'ext.TWIA.edge.capabilities.claim.dto.IncidentDTO', {'SubmittingClaim': true}); //
            }
            _.set(updatedPrevInjuryPartyVM, 'value', selectedInjuryIncidentVM);
            return updatedPrevInjuryPartyVM;
            
        });
        setShowInjuredPartyForm(true);
        setEditInjuredPartyForm(true);
    }, [claimVM]);

    const deleteInjuryRecord = useCallback((data) => {
        const injuryIncidents = _.get(claimVM, 'incidents.value', []);
        const deleteRecordIndex = injuryIncidents.findIndex(
            (item) => item.tempID === data.tempID && item.incidentType === data.incidentType
        );
        injuryIncidents.splice(deleteRecordIndex, 1);
        updateWizardData(claimVM);
    }, [claimVM]);

    const getFirstNamePropDamage = useCallback((data) => {
        return data?.fixPropIncidentContact?.firstName;
        
    }, []);

    const getLastNamePropDamage = useCallback((data) => {
        return data?.fixPropIncidentContact?.lastName;
    }, []);

    const getPhoneNumberPropDamage = useCallback((data) => {
        return data?.fixPropIncidentContact?.homeNumber || data?.fixPropIncidentContact?.cellNumber
            || data?.fixPropIncidentContact?.workNumber;
    }, []);

    const editPropDamageRecord = useCallback((data) => {
        const propDamageIncidents = _.get(claimVM, 'incidents.value', []);
        const selectedPropDamageIncidentVM = propDamageIncidents.find((item) =>
            data.incidentType === item.incidentType
            && data.tempID === item.tempID
        );
        setPropertyDamageVM((prevPropDamageVM) => {
            let updatedPrevPropDamageVM = prevPropDamageVM;
            if (!prevPropDamageVM.value) {
                updatedPrevPropDamageVM = viewModelService.create({
                    incidentType: 'FixedPropertyIncident',
                    policyLocation_TFPA: claimVM.policy?.lobs?.homeowner?.locations?.value[0],
                    fixPropIncidentContact: {
                      subtype: 'Person',
                    }
                  }, 'cc', 'ext.TWIA.edge.capabilities.claim.dto.IncidentDTO', {'SubmittingClaim': true}); //
            }
            _.set(updatedPrevPropDamageVM, 'value', selectedPropDamageIncidentVM);
            return updatedPrevPropDamageVM;
        });
        setShowPropDamageForm(true);
        setEditPropDamageForm(true);
    }, [claimVM]);

    const deletePropDamageRecord = useCallback((data) => {
        const propDamageIncidents = _.get(claimVM, 'incidents.value', []);
        const deleteRecordIndex = propDamageIncidents.findIndex(
            (item) => item.tempID === data.tempID && item.incidentType === data.incidentType
        );
        propDamageIncidents.splice(deleteRecordIndex, 1);
        updateWizardData(claimVM);
    }, [claimVM]);

    const writeValue = useCallback((value, path) => {
        _.set(claimVM, path, value);
        if (path === 'wasAnyoneInjured_TFPA' && !value) {
            const injuryIncidents =  _.filter(_.get(claimVM, 'incidents.value', []),
            (item) => item.incidentType !== 'InjuryIncident');
            _.set(claimVM, 'incidents.value', injuryIncidents);
        }
        if (path === 'isPropertyDamaged_TFPA' && !value) {
            const propDamageIncidents =  _.filter(_.get(claimVM, 'incidents.value', []),
            (item) => item.incidentType !== 'FixedPropertyIncident');
            _.set(claimVM, 'incidents.value', propDamageIncidents);
        }
        updateWizardData(claimVM);
    }, [claimVM]);

    const overrides = {
        '@field': {
            showOptional: false,
            showRequired: true,
            phoneWide: {
                labelPosition: 'top',
            },
        },
        criminalDamageContainer: {
            visible: !showInjuredPartyForm && !showPropDamageForm
        },
        injuredPartyBtnContainer: {
            visible: !!_.get(claimVM, 'wasAnyoneInjured_TFPA.value')
        },
        propertyDamageBtnContainer: {
            visible: !!_.get(claimVM, 'isPropertyDamaged_TFPA.value') &&  _.get(claimVM, 'incidents.value').filter((item) => item.incidentType === 'FixedPropertyIncident')?.length === 0
        },
        injuredPartyTable: {
            data: _.get(claimVM, 'incidents.value').filter((item) => item.incidentType === 'InjuryIncident')
        },
        propertyDamageTable: {
            data: _.get(claimVM, 'incidents.value').filter((item) => item.incidentType === 'FixedPropertyIncident')
        },
        injuredPartyForm: {
            injuredPartyVM, claimVM, updateWizardData, setShowInjuredPartyForm,
            visible: showInjuredPartyForm,
            setEditInjuredPartyForm,
            isEditInjuredPartyForm,
            onValidate
        },
        propDamageForm: {
            propertyDamageVM, claimVM, updateWizardData, setShowPropDamageForm,
            visible: showPropDamageForm,
            setEditPropDamageForm,
            isEditPropDamageForm,
            onValidate
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getFirstName,
            getLastName,
            getPhoneNumber,
            editInjuryRecord,
            deleteInjuryRecord,
            getFirstNamePropDamage,
            getLastNamePropDamage,
            getPhoneNumberPropDamage,
            editPropDamageRecord,
            deletePropDamageRecord,
            onInjuredPartyClick,
            onPropertyDamageClick,
            renderEdit,
            renderDelete,
            renderEditPropDamage,
            renderDeletePropDamage
        },
        resolveComponentMap: {
            injuredPartyFormComponent: InjuredPartyForm,
            propDamageFormComponent: PropertyDamageForm
        }
    };
    return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                onValueChange={writeValue}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                showErrors={showErrors}
            />
    );
}

FNOLLiabilityDetails.propTypes = wizardProps;
export default withRouter(FNOLLiabilityDetails);
